<div
    *ngFor="let item of items"
    [id]="labelToId(item.label) + '-menu'"
    (click)="this.toggleDropDown($event, item)">
  <div class="desktop-menu-header">
    <a
      class="desktop-link"
      [routerLink]="item.routerLink ?? null">
      <i id='{{ labelToId(item.label) }}-icon' class="desktop-icon {{ item.icon }}" ></i>
      <span class="desktop-menu-item-text">{{ item.label }}</span>
    </a>
  </div>
  <div
    *ngIf="hasChildren(item)"
    class="desktop-menu-list scrollable"
    [id]="labelToId(item.label) + '-children'">
    <ul
      *ngFor="let subItem of item.items"
      class="desktop-menu-sublist">
      <li class="desktop-menu-list-item">
        <a class="desktop-link" [routerLink]="subItem.routerLink">
          <i class="desktop-icon {{ subItem.icon }}"></i>
          <span class="desktop-menu-item-text">{{ subItem.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</div>
